<template>
  <div class="questionnaire-wrapper">
    <div class="questionnaire-main">
      <router-view></router-view>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .questionnaire-wrapper{
    min-height: 100vh;
    background: #F7F7F7;
    .questionnaire-main{
      position: relative;
      top: 92px;
      // margin-top: -6px;
      background: #FFF;
      z-index: 10;
      border-radius: 6px 6px 0 0;
    }
  }
</style>

<script type="text/javascript">
  export default {
    data() {
      return {}
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    created() {},
    mounted() {},
    methods: {},
  }
</script>



// WEBPACK FOOTER //
// src/components/Patient/Questionnaire/index.vue